// Modules
import React from 'react'

// Routes
import Routes from './routes/Main'

// Components
import Page from 'components/layout/page/Page'

// Hooks
// import useLanguage from 'hooks/system/useLanguage'

// Styles
import './PasswordChange.scss'

// Page: Password change
function PasswordChange () {
	// Data
	// const { translate } = useLanguage('pages.passwordChange')

	// Render
	return (
		<Page
			isPublic
			name="password-change">
			<Routes />
		</Page>
	)
}

// Export
export default PasswordChange
